// formik components
import { Formik, Form } from "formik";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

// example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// InvoiceDetail layout schemas for form and form feilds
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CompanyInfo from "./info";
import validation from "./schemas/validations";
import initialValues from "./schemas/initialValues";
import form from "./schemas/form";
import { CompanyService } from "services/companyService";
import { ImageService } from "services/imageService";
import toast from "react-hot-toast";
import Loading from "components/Common/Loading";
import { useEffect, useState } from "react";
import { InvoiceBooksService } from "services/invoiceBooksService";
import { useSelector } from "react-redux";
import { authSelector } from "redux/selector";

function InvoiceDetail() {
  const { formId, formField } = form;
  const { id } = useParams();
  const location = useLocation();
  const containEdit = location.pathname?.includes("/edit");
  const navigation = useNavigate();
  const [data, setData] = useState();
  const { user } = useSelector(authSelector);

  useEffect(() => {
    if (!id) return;
    (async () => {
      try {
        const { data } = await InvoiceBooksService.getById(id);
        setData(data);
      } catch (error) {
        toast.error(error?.response?.data?.message || "Lấy dữ liệu thất bại");
      }
    })();
  }, [id]);

  const handleBack = () => navigation(-1);

  const submitForm = async (values, actions) => {
    try {
      let payload;
      if (id) {
        if (values.used !== data.used) {
          payload = {
            ...values,
            isActive: values.status,
            company: user?.company?._id,
          };
        } else {
          payload = {
            ...values,
            invoiceSymbol: values.invoiceSymbol,
            numberOfRegistrations: values.numberOfRegistrations,
            isActive: values.status,
            company: user?.company?._id,
          };
        }
        await InvoiceBooksService.update(id, payload);
      } else {
        payload = { ...values, used: 0 };
        await InvoiceBooksService.create(payload);
      }
      actions.setSubmitting(false);
      !id && actions.resetForm();
      toast.success(`${id ? "Cập nhật" : "Tạo"} thành công`);
    } catch (error) {
      toast.error(error?.response?.data?.message || `${id ? "Cập nhật" : "Tạo"} thất bại`);
      actions.setSubmitting(false);
      console.error({ error });
    }
  };

  const handleSubmit = (values, actions) => {
    submitForm(values, actions);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3} mb={20}>
        <Grid container justifyContent="center" sx={{ height: "100%" }}>
          <Grid item xs={12} lg={12}>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <SoftBox p={2}>
                      <SoftBox>
                        <CompanyInfo
                          formData={{
                            values,
                            touched,
                            formField,
                            errors,
                            setFieldValue,
                          }}
                          data={data}
                        />
                        <SoftBox mt={10} width="100%" display="flex" justifyContent="space-between">
                          <SoftButton variant="gradient" color="light" onClick={handleBack}>
                            Trở về
                          </SoftButton>
                          {(!id || (id && containEdit)) && (
                            <SoftBox display="flex" gap={3}>
                              <SoftButton
                                disabled={isSubmitting}
                                type="submit"
                                variant="gradient"
                                color="dark"
                              >
                                {isSubmitting ? (
                                  <Loading width={25} height={25} />
                                ) : id && containEdit ? (
                                  "Cập nhật"
                                ) : (
                                  "Tạo"
                                )}
                              </SoftButton>
                            </SoftBox>
                          )}
                        </SoftBox>
                      </SoftBox>
                    </SoftBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default InvoiceDetail;
